// Recovered compiled webpack factory 87913. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { M: () => n });
  let n = new Set(["opacity", "clipPath", "filter", "transform"]);
}
